module.exports = __webpack_public_path__ + "c425d3f33c7cfa180fd670619665f6fe.woff2";